module.exports = __webpack_public_path__ + "static/media/submersible.eae48695.svg";